import axiosInstance from "../../utils/axiosInstance";
import { getAuthHeaders } from "../../utils/authHeader";

const BASE_URL = `/meeting-integrations`;

export const fetchAllIntegration = async (search = "") => {
  const res = await axiosInstance.get(`${BASE_URL}`, {
    ...getAuthHeaders(),
    params: {
      search,
    },
  });

  return res.data;
};

export const fetchIntegration = async (uuid) => {
  const res = await axiosInstance.get(`${BASE_URL}/${uuid}`, getAuthHeaders());
  return res.data;
};

export const fetchIntegrationBySource = async (sourceName) => {
  const res = await axiosInstance.get(
    `${BASE_URL}/source/${sourceName}`,
    getAuthHeaders(),
  );
  return res.data;
};
